import { render, staticRenderFns } from "./ReportsOrganizationalViolencePdf.vue?vue&type=template&id=d2e88c00&scoped=true&"
import script from "./ReportsOrganizationalViolencePdf.vue?vue&type=script&lang=js&"
export * from "./ReportsOrganizationalViolencePdf.vue?vue&type=script&lang=js&"
import style0 from "./ReportsOrganizationalViolencePdf.vue?vue&type=style&index=0&id=d2e88c00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e88c00",
  null
  
)

export default component.exports